import { useSelector } from "react-redux";
import { io } from "socket.io-client";
import { SOCKET_EVENT } from "../data/socket.enum";
import { socketId } from "../data/socketID";
import * as Sentry from "@sentry/browser";

let socket = {};

export const useRoomConnection = () => {
  const { Tester_IDX, ROOM_IDX } = useSelector((state) => state.userInfo);
  const { myRoomId, myPeerId, con_my_peer_type } = socketId(
    ROOM_IDX,
    Tester_IDX
  );
  const userInfo = useSelector((state) => state.userInfo);

  const disconnect = () => {
    if (socket) {
      socket.disconnect();
    }
  };

  const connect = () => {
    socket = io.connect("https://rtcweb.insahr.co.kr", {
      transports: ["websocket"],
    });
  };

  const joinRoom = () => {
    if (myRoomId && myPeerId && con_my_peer_type) {
      Sentry.captureMessage(
        "룸 접속_" +
          userInfo.Tester_Name +
          "_" +
          myRoomId +
          "_" +
          myPeerId +
          "_" +
          con_my_peer_type
      );
      socket?.emit(
        SOCKET_EVENT.JOIN_ROOM,
        myRoomId,
        myPeerId,
        con_my_peer_type
      );
    }
  };

  //감독관에게 소켓 메세지 전송(펜딩, 검사 완료)
  const sendToExamTopic = (targetSocketId, sendMessage) => {
    if (Object.keys(socket).length === 0) return;
    socket?.emit(SOCKET_EVENT.EXAM, "to", {
      targetSocketId: targetSocketId,
      message: { message: sendMessage, peerId: myPeerId },
    });
  };

  const socketOff = () => {
    socket.off(SOCKET_EVENT.USER_CHAT);
    socket.off(SOCKET_EVENT.USER_CHAT_READ);
    socket.off(SOCKET_EVENT.USER_VOICE_CHAT);
  };

  //소켓이 비어있으면 연결 (재연결 막기)
  if (typeof window !== "undefined" &&                 
    Object.keys(socket).length === 0 && socket.constructor === Object) {
  socket = io.connect("https://rtcweb.insahr.co.kr", { transports: ["websocket"] });
}

  return {
    socket,
    disconnect,
    connect,
    joinRoom,
    sendToExamTopic,
    socketOff,
  };
};
